// extracted by mini-css-extract-plugin
module.exports = {"ball_container":"index_ball_container__1VtNJ","bottom_text":"index_bottom_text__RPcBu"};